import { Component } from "react";
import { IoChevronForwardOutline } from "react-icons/io5";

class FAQAccordion extends Component {
  render() {
    const faqs = this.props.faqs || [
      {
        id: "faq1",
        question: "How do I return an online order?",
        answer:
          "XLP Members and guests can return online orders at most XLP stores or ship their return back to us.",
      },
      {
        id: "faq2",
        question: "How do I return a XLP store purchase?",
        answer:
          "You can take the items you want to return and your proof of purchase to any XLP store.",
      },
      {
        id: "faq3",
        question: "What about defective or flawed items?",
        answer:
          "We stand behind our gear. If it's been less than 60 days since your purchase, simply return the item. If it's been more than 60 days and your item is potentially defective or flawed, contact support.",
      },
      {
        id: "faq4",
        question: "Does XLP offer price adjustments?",
        answer:
          "Yes, we offer XLP Members price adjustments for eligible items within a specific timeframe.",
      },
    ];

    return (
      <div className="accordion" id="faqAccordionRoot">
        {faqs.map((faq) => (
          <div className="accordion-item border-0 border-bottom" key={faq.id}>
            <h2 className="accordion-header" id={`heading-${faq.id}`}>
              <button
                className="accordion-button collapsed bg-white text-dark shadow-none px-0 py-4"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#collapse-${faq.id}`}
                style={{ fontSize: "18px", fontWeight: "500" }}
              >
                <IoChevronForwardOutline
                  className="me-3"
                  size={20}
                  color="#b54a2e"
                />
                {faq.question}
              </button>
            </h2>
            <div
              id={`collapse-${faq.id}`}
              className="accordion-collapse collapse"
              data-bs-parent="#faqAccordionRoot"
            >
              <div className="accordion-body px-0 pt-0 pb-4 text-secondary">
                <p className="mb-0 ms-5" style={{ lineHeight: "1.6" }}>
                  {faq.answer}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }
}

export default FAQAccordion;
